import React from 'react'
import loadable from '@loadable/component'

import { Skeletons } from '@usap/widgets'

const { Fallback } = Skeletons

const Article = loadable(
  () => import(
    './Article.component'
  ),
  <Fallback height={1890} />,
)

export default Article
